import { useMemo, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function usePagination(items, pageSize = 10) {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil((items?.length || 0) / pageSize));
  useEffect(() => { if (page > totalPages) setPage(1); }, [items?.length, totalPages, page]);
  const paged = useMemo(() => {
    const start = (page - 1) * pageSize;
    return (items || []).slice(start, start + pageSize);
  }, [items, page, pageSize]);
  return { page, setPage, totalPages, paged, total: items?.length || 0, pageSize };
}

export default function Pagination({ page, setPage, totalPages, total, pageSize, testid = "pagination" }) {
  if (!total) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  const pagesToShow = () => {
    const arr = [];
    const push = (p) => arr.push(p);
    if (totalPages <= 7) { for (let i = 1; i <= totalPages; i++) push(i); return arr; }
    push(1);
    if (page > 3) push("...");
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) push(i);
    if (page < totalPages - 2) push("...");
    push(totalPages);
    return arr;
  };
  return (
    <div data-testid={testid} className="flex flex-col md:flex-row md:items-center justify-between gap-3 px-3 py-3 border-t border-slate-200 bg-slate-50/50 text-xs">
      <div className="text-slate-500">
        Menampilkan <span className="font-semibold text-slate-800">{from}</span>–<span className="font-semibold text-slate-800">{to}</span> dari <span className="font-semibold text-slate-800">{total}</span> data
      </div>
      <div className="flex items-center gap-1">
        <button data-testid={`${testid}-prev`} disabled={page === 1} onClick={() => setPage(page - 1)}
          className="p-1.5 rounded-sm border border-slate-200 disabled:opacity-40 hover:bg-white">
          <ChevronLeft size={14}/>
        </button>
        {pagesToShow().map((p, i) => p === "..." ? (
          <span key={`e${i}`} className="px-2 text-slate-400">…</span>
        ) : (
          <button key={p} data-testid={`${testid}-page-${p}`}
            onClick={() => setPage(p)}
            className={`min-w-[28px] px-2 py-1 rounded-sm border text-[12px] ${p === page ? "brand-btn border-transparent" : "border-slate-200 hover:bg-white"}`}>
            {p}
          </button>
        ))}
        <button data-testid={`${testid}-next`} disabled={page === totalPages} onClick={() => setPage(page + 1)}
          className="p-1.5 rounded-sm border border-slate-200 disabled:opacity-40 hover:bg-white">
          <ChevronRight size={14}/>
        </button>
      </div>
    </div>
  );
}
